export const SITE = {
  name: "80 Metrics Property Advisory",
  short: "80 Metrics",
  tagline: "Evidence over opinion.",
};

// Real Google links supplied by the owner. The write-review URL resolves to the
// verified 80 Metrics place (place_id ChIJxQW4FStD1moRtwIRl2ZFtPo). The listing's
// live rating/count could not be verified from the build environment — do NOT add
// star ratings or review counts anywhere unless re-verified.
export const GOOGLE_REVIEW_WRITE_URL = "https://g.page/r/CbcCEZdmRbT6EAE/review";
export const GOOGLE_MAPS_LISTING_URL =
  "https://www.google.com/maps/search/?api=1&query=Google&query_place_id=ChIJxQW4FStD1moRtwIRl2ZFtPo";

// Approved photo: Matthew holding both property-investment books.
// Localised from the owner-supplied asset (previously a remote customer-assets URL).
// Keep full head, upper body and both books visible at all breakpoints.
export const MATTHEW_PHOTO = "/assets/matthew-clark.webp";

// Public business contact routes, as listed on the official site (80metrics.com.au/about-us/).
export const CONTACT_EMAIL = "team@80metrics.com.au";
export const CONTACT_PHONE_DISPLAY = "+61 3 8773 4599";
export const CONTACT_PHONE_TEL = "+61387734599";

// Legal entity + corporate credentials (per the current privacy policy,
// 7 October 2026). The corporate estate agent's licence belongs to
// Key Choice Group Pty Ltd — never present it as a personal licence.
export const CORPORATE = {
  entity: "Key Choice Group Pty Ltd",
  abn: "ABN 27 106 387 786",
  licence: "Corporate Estate Agent’s Licence 093462L",
  address: "Shop 2, 10 Eramosa Road East, Somerville VIC 3912",
  trading_line: "Key Choice Group Pty Ltd trading as 80 Metrics Property Advisory",
};

// Owner-supplied, verified public booking page (15-minute introductory call).
export const CALENDLY_URL = "https://calendly.com/team-80metrics/invest-sell-or-negotiate-smarter";

export const MATTHEW = {
  name: "Matthew Clark",
  role: "Founder & Head of Client Strategy",
  quals: "Dip. Prop. (Agency Mgmt) · QPIA · Dip. Fin. Services",
  author: "Two-time Amazon bestselling author on property investment",
};

export const IMAGES = {
  // Source-verified Australian residential photography, localised.
  // Photographers, source pages and licences: /app/ASSET_MANIFEST.md.
  stairs: {
    src: "/assets/insights-melbourne-aerial.jpg",
    alt: "Aerial view of an ordinary suburban street grid with tile-roofed houses, Melbourne, Australia",
  },
  living: {
    src: "/assets/insights-kiama-aerial.jpg",
    alt: "Aerial view of Kiama Downs, a coastal town in New South Wales, Australia",
  },
  facade: {
    src: "/assets/insights-shoalhaven-house.jpg",
    alt: "Weatherboard and brick-veneer houses on a quiet street in Shoalhaven Heads, New South Wales, Australia",
  },
  aerial: {
    src: "/assets/insights-melbourne-aerial.jpg",
    alt: "Aerial view of a typical Australian suburb of detached houses, Melbourne",
  },
};

export const MARQUEE_ITEMS = [
  "SuburbIQ",
  "Property & Portfolio Assessment",
  "Buyer Advocacy",
  "Vendor Advocacy",
  "80+ metrics",
  "Evidence over opinion",
  "Independent by design",
];

export const DECISIONS = [
  {
    key: "buy",
    label: "BUY",
    question:
      "Which suburb and property fit my goals and risk profile — and what should I pay?",
    link: "/buyer-advocacy",
    linkLabel: "Buyer Advocacy",
  },
  {
    key: "sell",
    label: "SELL",
    question:
      "Should I sell? When should I act, how should I sell — and which agent should I choose?",
    link: "/vendor-advocacy",
    linkLabel: "Vendor Advocacy",
  },
  {
    key: "retain",
    label: "RETAIN",
    question:
      "Is my property still serving my goals — or is my capital better used elsewhere?",
    link: "/property-portfolio-assessment",
    linkLabel: "Property & Portfolio Assessment",
  },
];

export const CASES = [
  {
    label: "BOUGHT",
    title: "A growth corridor the headlines missed",
    body: "Research identified stronger fundamentals that better matched the client brief.",
  },
  {
    label: "RETAINED",
    title: "An investment restructured to support a home purchase",
    body: "The Assessment identified a way to retain the investment while improving capacity to purchase the home, alongside the client’s financial planner.",
  },
  {
    label: "SOLD",
    title: "A private sale without public exposure",
    body: "Privacy and timing mattered. A qualified buyer was found off-market without a public campaign.",
  },
  {
    label: "WALKED AWAY",
    title: "An Airbnb plan the zoning wouldn’t allow",
    body: "The intended use was not supported by the zoning, so the clients walked away before committing.",
  },
];

export const HOME_FAQS = [
  {
    q: "What does 80 Metrics Property Advisory help with?",
    a: "We help clients decide whether to buy, sell or retain property, then provide advocacy when they choose to act.",
  },
  {
    q: "Do I need SuburbIQ or a Property & Portfolio Assessment before advocacy?",
    a: "No. Both are optional. You can engage Buyer Advocacy or Vendor Advocacy directly.",
  },
  {
    q: "How are your fees structured?",
    a: "Our professional fees are fixed and published. We do not receive selling-agent commissions or referral fees, and eligible earlier-service payments may be credited once toward a later engagement.",
  },
  {
    q: "What makes 80 Metrics different?",
    a: "We start with your goals, circumstances and evidence before recommending a course of action. The right answer may be to buy, sell, retain — or walk away.",
  },
];

export const FAQ_CATEGORIES = [
  { key: "which", label: "Which service do I need?" },
  { key: "suburbiq", label: "SuburbIQ" },
  { key: "review", label: "Property & Portfolio Assessment" },
  { key: "buyer", label: "Buyer Advocacy" },
  { key: "vendor", label: "Vendor Advocacy" },
];

export const FAQS = [
  {
    cat: "which",
    q: "Which 80 Metrics service is right for me?",
    a: "If your question is about a suburb or market, start with SuburbIQ. If it concerns a specific property or portfolio you already own, consider a Property & Portfolio Assessment. If you are buying or assessing a specific property to purchase, Buyer Advocacy is the appropriate service. If you are ready to sell, Vendor Advocacy is designed for that process.",
  },
  {
    cat: "which",
    q: "Do I need SuburbIQ or an Assessment before engaging an advocate?",
    a: "No. Both are optional. You can engage Buyer Advocacy or Vendor Advocacy directly when you are ready to act.",
  },
  {
    cat: "which",
    q: "What if I’m not sure what I need?",
    a: "Tell us what you’re trying to decide. We’ll point you to the appropriate starting point — including telling you if we do not think you need a paid service.",
  },
  {
    cat: "which",
    q: "How are your fees structured?",
    a: "Fixed and published: SuburbIQ $220; Property & Portfolio Assessment $2,200; Vendor Advocacy $4,400; Buyer Advocacy tiered by agreed purchase budget — under $1,000,000: $13,200; $1,000,000 to under $2,000,000: $16,500; $2,000,000 and above: $22,000 (a $2,200 retainer at engagement, credited to the total fee, balance at settlement). All incl. GST. Eligible earlier-service payments may be credited once toward a later engagement.",
  },
  {
    cat: "suburbiq",
    q: "Can SuburbIQ help me weigh up buying, selling or retaining?",
    a: "Yes — when your question is about the suburb or market. SuburbIQ uses the relevant metrics to help you understand the evidence around a general buy, sell or retain decision. If you want advice about a specific property you already own, a Property & Portfolio Assessment may be more appropriate. If you are actively buying or assessing a specific property to purchase, Buyer Advocacy is the appropriate service.",
  },
  {
    cat: "suburbiq",
    q: "What exactly do I receive with SuburbIQ?",
    a: "A professionally reviewed suburb report and a personal video walkthrough from Matthew Clark, focused on the question you want answered. You tell us the decision you’re weighing up; we identify the metrics that best help answer it.",
  },
  {
    cat: "suburbiq",
    q: "How fast is SuburbIQ delivered?",
    a: "Within 2 business days of payment. Your confirmation page shows the expected delivery date for your order.",
  },
  {
    cat: "suburbiq",
    q: "Is SuburbIQ personal advice or a valuation?",
    a: "No. SuburbIQ is suburb-level research and professional commentary. It is not a formal valuation and not a property-specific recommendation.",
  },
  {
    cat: "suburbiq",
    q: "What if the report doesn’t answer my question?",
    a: "SuburbIQ carries a money-back answer guarantee. If the report doesn’t answer the question we agreed, you can ask for your fee back.",
  },
  {
    cat: "review",
    q: "Who is the Property & Portfolio Assessment for?",
    a: "Anyone who wants personalised advice about a specific property or portfolio they already own — up to four properties — covering performance, fit with goals, holding costs, risk, alternatives and opportunity cost.",
  },
  {
    cat: "review",
    q: "What can an Assessment recommend?",
    a: "Retain, restructure, sell or buy — whatever the evidence supports. Advice does not have to lead to a transaction; an Assessment may recommend retaining.",
  },
  {
    cat: "buyer",
    q: "When should I engage Buyer Advocacy?",
    a: "When you’re ready to buy, or assessing a specific property to purchase. It covers market selection, property assessment, due diligence, price evidence, negotiation and representation.",
  },
  {
    cat: "buyer",
    q: "What does Buyer Advocacy cost?",
    a: "Tiered by agreed purchase budget: under $1,000,000 — $13,200; $1,000,000 to under $2,000,000 — $16,500; $2,000,000 and above — $22,000 (all incl. GST). A $2,200 retainer is payable at engagement and credited to the total fee; the balance is payable at settlement. Your fixed fee is agreed at engagement using your purchase budget — it is not calculated as a percentage of the final purchase price.",
  },
  {
    cat: "vendor",
    q: "What does Vendor Advocacy cover?",
    a: "Timing, pricing, agent selection, campaign decisions and independent sale oversight — for clients ready to sell. Vendor Advocacy is $4,400 incl. GST, payable at settlement.",
  },
];

export const FEES = [
  {
    key: "suburbiq",
    name: "SuburbIQ",
    price: "$220 incl. GST",
    meta: "Professionally reviewed suburb report + video walkthrough",
    payment: "Payment: upfront · Delivery: within 2 business days of payment",
    link: "/suburbiq",
    includes: [
      "One suburb question, professionally answered",
      "80+ metrics reviewed against your decision",
      "Professionally reviewed suburb report",
      "Video walkthrough from Matthew Clark",
      "Delivered within 2 business days",
      "Money-back answer guarantee",
    ],
  },
  {
    key: "review",
    name: "Property & Portfolio Assessment",
    price: "$2,200 incl. GST",
    meta: "Up to four properties",
    payment: "Payment: on completion · Delivery: within 5 business days",
    link: "/property-portfolio-assessment",
    includes: [
      "Personalised advice on property you already own — up to four properties",
      "Performance, fit with goals, holding costs, risk, alternatives and opportunity cost",
      "Retain, restructure, sell or buy options weighed on evidence",
      "Written assessment with clear recommendations",
      "Two meetings with Matthew Clark — discovery and findings walkthrough",
    ],
  },
  {
    key: "buyer",
    name: "Buyer Advocacy",
    price: "From $13,200 incl. GST",
    meta: "Fee determined by agreed purchase budget",
    payment: "Retainer: $2,200 at engagement, credited to total fee",
    link: "/buyer-advocacy",
    includes: [
      "Market selection and brief definition against your goals and risk profile",
      "Property assessment, due diligence and price evidence",
      "Search and shortlisting — including off-market",
      "Negotiation and auction representation through to settlement",
    ],
  },
  {
    key: "vendor",
    name: "Vendor Advocacy",
    price: "$4,400 incl. GST",
    meta: "Independent sale strategy and campaign oversight",
    payment: "Payment: at settlement",
    link: "/vendor-advocacy",
    includes: [
      "Independent view on timing, pricing and method of sale",
      "Agent selection without referral-fee conflicts",
      "Campaign decisions and independent sale oversight",
      "Negotiation support through to settlement",
    ],
  },
];

export const CREDIT_TERMS = [
  "One credit per client, per engagement. The credit equals the eligible fee already paid.",
  "A credit applies when you move from SuburbIQ or a Property & Portfolio Assessment into another eligible 80 Metrics service within 12 months of the original payment.",
  "The credit is applied once, at invoice, against the later service’s fixed professional fee.",
  "Credits reduce the later fee only — they are not paid out in cash, cannot be used twice, and do not stack.",
  "Unused credits lapse. Buyer Advocacy engagements begin with a $2,200 retainer at engagement, credited toward the total fee.",
  "Scope and fees are agreed in writing before any paid work begins.",
];

export const SERVICES = {
  "buyer-advocacy": {
    label: "BUY",
    name: "Buyer Advocacy",
    fee: "From $13,200 incl. GST",
    serviceKey: "buyer",
    boundary:
      "Working out where and what to buy — or assessing a specific property? We start with your goals, budget and circumstances, then location and property selection, assessment, due diligence, price evidence, negotiation and representation.",
    headline: "Buy with evidence, not pressure.",
    intro:
      "For investors and buyers deciding where and what to buy — or assessing a specific property. We start with your goals, budget and circumstances, identify suitable locations and property options, test them against 80+ metrics, and negotiate on your side of the table only.",
    points: [
      "Brief defined by your goals, budget and circumstances",
      "Location and property selection, search and shortlisting — including off-market",
      "Evidence-based due diligence and price guidance",
      "Negotiation and auction representation through to settlement",
    ],
  },
  "vendor-advocacy": {
    label: "SELL",
    name: "Vendor Advocacy",
    fee: "$4,400 incl. GST",
    serviceKey: "vendor",
    boundary:
      "Ready to sell? Timing, pricing, agent selection, campaign decisions and independent sale oversight.",
    headline: "Sell on your terms, with the right agent.",
    intro:
      "For owners deciding whether to sell, when to act, how to sell — and which agent should represent them. We select and manage the agent, oversee the method and campaign, and stay on your side through negotiation.",
    points: [
      "Independent view on timing, pricing and method of sale",
      "Agent selection without referral-fee conflicts",
      "Campaign decisions and independent sale oversight",
      "Negotiation support through to settlement",
      "We work for you and are paid by you — we do not receive referral fees or share in your selling agent’s commission",
      "Our $4,400 incl. GST fee is separate from the selling agent’s fees and campaign costs",
    ],
  },
  "property-portfolio-review": {
    label: "RETAIN",
    name: "Property & Portfolio Assessment",
    fee: "$2,200 incl. GST",
    serviceKey: "review",
    boundary:
      "Own it already? Personalised advice about a specific property or portfolio you already own.",
    headline: "Hold, restructure or sell — decided on evidence.",
    intro:
      "For a specific property or portfolio you already own — up to four properties. We assess performance, fit with your goals, holding costs, risk, alternatives and opportunity cost, with recommendations in writing.",
    points: [
      "Analysis of up to four properties against your goals",
      "Holding costs, risk, alternatives and opportunity cost assessed",
      "Retain, restructure, sell or buy options weighed on evidence",
      "Written assessment with clear recommendations",
      "Two meetings with Matthew Clark — discovery and findings walkthrough",
    ],
  },
};

export const SERVICE_FIT = [
  {
    question: "Weighing up a suburb or market?",
    service: "SuburbIQ",
    when: "For general suburb-level questions about buying, selling or retaining.",
    action: null,
  },
  {
    question: "Need advice about property you already own?",
    service: "Property & Portfolio Assessment",
    when: "For a specific property or portfolio you own, where you want to assess performance, fit, alternatives and opportunity cost.",
    action: { to: "/property-portfolio-assessment", label: "Explore Assessment" },
  },
  {
    question: "Investing — where should I buy, and what suits my circumstances?",
    service: "Buyer Advocacy",
    when: "For personalised location and property selection, assessment, due diligence, negotiation and representation.",
    action: { to: "/buyer-advocacy", label: "Explore Buyer" },
  },
  {
    question: "Ready to sell?",
    service: "Vendor Advocacy",
    when: "For pricing, agent selection, campaign decisions and independent sale oversight.",
    action: { to: "/vendor-advocacy", label: "Explore Vendor" },
  },
];

export const CONTACT_OPTIONS = [
  { key: "suburbiq", label: "Weigh up a suburb or market", service: "SuburbIQ" },
  { key: "review", label: "Review a property or portfolio I already own", service: "Property & Portfolio Assessment" },
  { key: "buyer", label: "Buy or assess a property to purchase", service: "Buyer Advocacy" },
  { key: "vendor", label: "Sell a property", service: "Vendor Advocacy" },
  { key: "unsure", label: "I’m not sure yet", service: null },
];

export const ARTICLES = [
  {
    slug: "the-price-you-pay-is-the-risk-you-take",
    category: "BUYING STRATEGY",
    directorsNote: true,
    title: "The price you pay is the risk you take",
    date: "14 May 2026",
    isoDate: "2026-05-14",
    read: "4 min read",
    image: "stairs",
    excerpt:
      "Most buyers negotiate the last $10,000 and ignore the first $100,000. The evidence that matters is gathered before you fall in love with the property.",
    body: [
      "Every property purchase carries two prices: the one on the contract, and the one embedded in the risk you accepted to get there. Buyers who treat the purchase price as the only number that matters routinely overpay — not at auction, but in the weeks before it, when they stop testing the evidence.",
      "The metrics that answer ‘what should I pay?’ are not the median price on a portal. They are the relationship between days on market and vendor discounting, the depth of competing stock at the same price point, the rental evidence underneath the asking range, and the rate at which comparable sales are actually clearing.",
      "When those numbers are assembled before you inspect, something useful happens: the asking price stops being an anchor and becomes a claim. Some claims hold up. Many don’t. The discipline is deciding your number from the evidence — then letting the property compete for your money, not the other way around.",
      "This is why we start every buyer brief with the metrics rather than the listings. The right property at the wrong price is still the wrong decision. Evidence first, emotion second, negotiation last — in that order.",
    ],
  },
  {
    slug: "choosing-an-agent-is-a-decision",
    category: "SELLING STRATEGY",
    title: "Choosing an agent is a decision, not a default",
    date: "28 April 2026",
    isoDate: "2026-04-28",
    read: "4 min read",
    image: "living",
    excerpt:
      "The agent with the most boards on your street is not automatically the agent who will get you the best result. Selection is a measurable exercise.",
    body: [
      "Most vendors interview three agents and choose the one who quotes the highest price. That is not selection — it is an auction for your listing, and the currency is your expectation. The quoted price costs the agent nothing. The wrong method, timing and negotiation cost you plenty.",
      "Agent selection should be treated like any other evidence-based decision. What is their clearance rate on comparable stock, not all stock? How do their final sale prices compare with their initial quotes? Who actually negotiates — the person who pitched, or someone you meet on auction day?",
      "The method matters as much as the person. Auction, private treaty, expressions or off-market each suit different properties, different markets and different vendors. Privacy and timing are legitimate constraints — a quiet sale to a qualified buyer can outperform a public campaign when the circumstances call for it.",
      "Independent vendor advocacy exists because these questions are hard to ask from inside the process. When your adviser earns nothing from the agent and nothing from the referral, the only agenda left is yours.",
    ],
  },
  {
    slug: "hold-restructure-or-sell",
    category: "PORTFOLIO STRATEGY",
    title: "Hold, restructure or sell: the questions a review should answer",
    date: "9 April 2026",
    isoDate: "2026-04-09",
    read: "5 min read",
    image: "facade",
    excerpt:
      "The most expensive property decisions are the ones never examined. A portfolio assessment starts with one question: is this asset still doing the job you bought it for?",
    body: [
      "Properties drift out of alignment quietly. The investment that suited your goals eight years ago may now be working against them — concentrated in the wrong market, structured against the wrong debt, or simply underperforming the alternatives you can no longer see from inside it.",
      "A proper review does not begin with ‘should I sell?’ It begins with your position: what the asset earns, what it costs, what it’s worth, what you owe against it, and what you need it to do next. Only then do the options — retain, restructure, sell, or buy — get weighed on evidence rather than sentiment.",
      "Sometimes the answer is to keep the asset and change the structure around it. We recently worked alongside a client’s financial planner to retain an investment while restructuring it to support a home purchase — the obvious answer, selling, would have been the weaker one.",
      "And sometimes the honest recommendation is to do nothing at all. Advice that can end in ‘retain’ is advice you can trust when it says ‘act’.",
    ],
  },
  {
    slug: "why-headline-medians-mislead",
    category: "MARKET INSIGHT",
    title: "Why headline medians mislead suburb decisions",
    date: "19 March 2026",
    isoDate: "2026-03-19",
    read: "4 min read",
    image: "aerial",
    excerpt:
      "A suburb median is an average of everything, which makes it a description of nothing. Better questions need better metrics.",
    body: [
      "‘Median house price up 8%’ is the most repeated and least useful number in property. A median moves when prices move — but it also moves when the mix of sales changes, when renovators flood a quarter, or when a handful of prestige sales land in a small sample. The headline moves; your decision shouldn’t.",
      "The metrics that actually answer a suburb question sit underneath the median: sales volume and its trend, days on market, vendor discounting, the split between house and unit performance, rental yield against holding costs, and what similar budgets are buying one suburb over.",
      "None of these numbers is exotic. What’s rare is assembling them against a specific decision. ‘Is this suburb good?’ is unanswerable. ‘Does this suburb’s evidence support what I’m trying to do, at this price, over my timeframe?’ — that is a question data can answer.",
      "That is the entire premise of SuburbIQ: your question, the metrics that answer it, and professional commentary on what the evidence does and doesn’t say. Data is everywhere. Answers aren’t.",
    ],
  },
];

export const TRACK_RECORD = [
  {
    label: "PROPERTY",
    body: "Licensed Victorian real estate professional with experience across buyer and vendor representation.",
  },
  {
    label: "FINANCE",
    body: "Built and led Key Choice Group, with more than $1 billion in lending across the business during that period.",
  },
  {
    label: "AUTHOR",
    body: "Two-time Amazon bestselling author on property investment.",
  },
  {
    label: "STRATEGY",
    body: "Brings property, market analysis and finance experience together when assessing the trade-offs behind a client’s decision.",
  },
];

// "What you receive / How it works" walkthroughs — agreed deliverables only,
// no invented inclusions. Buyer/Vendor entries describe the service process,
// not a report deliverable.
export const WALKTHROUGHS = {
  suburbiq: {
    title: "What you receive",
    steps: [
      { name: "Your question, agreed", body: "Tell us what you’re weighing up. We confirm the exact suburb question with you before work begins." },
      { name: "The relevant evidence", body: "We select and review the metrics that best answer your question — the evidence that matters, not a data dump." },
      { name: "Report + Matthew’s walkthrough", body: "A professionally reviewed suburb report, with Matthew’s personal video walkthrough of what the evidence does and doesn’t say." },
    ],
  },
  review: {
    title: "What you receive",
    steps: [
      { name: "Assessment", body: "Performance, fit with your goals, holding costs, risk, alternatives and opportunity cost — for up to four properties you already own." },
      { name: "Written assessment + recommendations", body: "The options — retain, restructure, sell or buy — weighed on evidence, with clear written recommendations." },
      { name: "Two meetings", body: "A discovery meeting to understand your position, and a findings walkthrough with Matthew Clark to talk the recommendations through." },
    ],
  },
  buyer: {
    title: "How it works",
    steps: [
      { name: "Location & property selection", body: "Your goals, budget and circumstances define the brief — then we identify suitable locations and property options, including off-market." },
      { name: "Assessment", body: "Property assessment, due diligence and price evidence before you commit." },
      { name: "Representation", body: "Negotiation and auction representation through to settlement — on your side of the table only." },
    ],
  },
  vendor: {
    title: "How it works",
    steps: [
      { name: "Sale planning", body: "An independent view on timing, pricing and method of sale." },
      { name: "Agent selection", body: "The right agent selected without referral-fee conflicts." },
      { name: "Campaign oversight", body: "Independent oversight of the campaign, with negotiation support through to settlement." },
    ],
  },
};

// The approved structure of every SuburbIQ report and Matthew's walkthrough.
export const REPORT_STRUCTURE = [
  { name: "Answer", body: "A direct answer to the question we agreed, in plain English." },
  { name: "Evidence", body: "The metrics behind the answer — and what they actually show." },
  { name: "Trade-offs", body: "The competing considerations the evidence surfaces." },
  { name: "Assumptions", body: "What we assumed, so you can judge the answer in context." },
];

// Genuine sample media for the SuburbIQ deliverable. NOTHING renders publicly
// while status is "unpublished". Publish only with an owner-approved,
// anonymised sample whose supplier licence permits public display — the
// Parkdale supplier report carries htag.com.au attribution and its public
// display rights are unconfirmed (see LAUNCH_STATUS.md).
export const SUBURBIQ_MEDIA = {
  status: "unpublished",
  videoUrl: null,
  posterUrl: null,
  transcriptUrl: null,
  sampleImages: [], // [{ src, alt, caption }]
  samplePdfUrl: null,
};

// Corporate brochure — APPROVED final PDF supplied by owner 3 Nov 2026
// ("80 Metrics Brochure — Approved 3 November 2026.pdf", 20 pages,
// 8,566,712 bytes, SHA-256 b56a3ef4…5be3). Owner direction 3 Nov 2026:
// published UNGATED (no login, no email capture) at the stable /brochure
// URL, which hands off to the versioned static asset below. Preserve the
// PDF bytes exactly — do not recreate, rewrite or truncate.
export const BROCHURE_FILE_URL = "/assets/brochure/80-metrics-brochure-approved-2026-11-03.pdf";
export const BROCHURE = {
  status: "published",
  pdfUrl: "/brochure",
  coverUrl: null,
  version: "Approved 3 November 2026",
  date: "3 November 2026",
  gated: false,
  meta: "PDF · 20 pages · approx. 8.6 MB",
};

// Downloadable resource slots (guides, checklists, playbooks).
// Public mode: a resource card renders ONLY when status === "published" AND
// fileUrl is set. Empty/missing/unapproved files stay hidden publicly — no
// fake links, no coming-soon dead ends. Owner preview (?media-preview=1 on
// non-production hosts) shows a labelled placement frame.
//
// Status vocabulary:
//   "unpublished" — hidden everywhere until a final approved PDF is supplied
//   "draft"       — editorial-review draft supplied; awaiting revised final
//   "hold"        — deliberately held back (licence / edition / positioning)
//   "published"   — approved for public download
//
// NOTHING here is publicly visible yet. Upload mapping is recorded in
// LAUNCH_STATUS.md. Source assets must be supplied by the owner; drafts must
// not be exposed, and their content must not be copied into site copy.
export const RESOURCES = [
  {
    // Buyer Advocacy — secondary download below the service/process/fee
    // content. Final corrected file supplied by owner 31 Oct 2026:
    // Shop 2, 10 Eramosa Road East, Somerville VIC 3912 · (03) 8773 4599 ·
    // team@80metrics.com.au; corrected inspection/finance/insurance/deposit
    // wording. Interactive PDF — 40 fillable fields preserved (do not flatten).
    id: "buyer-purchase-checklist",
    service: "buyer-advocacy",
    title: "Buyer Purchase Checklist",
    summary: "A practical checklist for the key steps from legal review to settlement — know what fits, test the evidence, and keep control of the purchase.",
    formatNote: "Interactive PDF — fill it in as you go.",
    release: "approved",
    status: "published",
    fileUrl: null,
    gated: true,
    coverUrl: "/assets/resources/buyer-purchase-checklist-cover.jpg",
    pageCount: 5,
    fileSize: "1.6 MB",
    reviewedAt: "31 October 2026",
  },
  {
    // Vendor Advocacy — secondary resource. Final redesigned PDF supplied by
    // owner 31 Oct 2026. 15 pages, 50 fillable fields preserved.
    id: "smart-sellers-playbook",
    service: "vendor-advocacy",
    title: "The Smart Seller’s Playbook",
    summary: "The do’s and don’ts of selling — seven decisions to take control of your sale. Includes an agent comparison scorecard, net-proceeds worksheet and pre-launch checklist.",
    release: "approved",
    status: "published",
    fileUrl: null,
    gated: true,
    coverUrl: "/assets/resources/smart-sellers-playbook-cover.jpg",
    pageCount: 15,
    fileSize: "2.3 MB",
    reviewedAt: "31 October 2026",
  },
  {
    // Vendor Advocacy — secondary resource. Final redesigned PDF supplied by
    // owner 31 Oct 2026. 14 pages, 25 fillable fields preserved. Card title
    // matches the supplied asset title ("The Confident Seller" is the cover
    // series line inside the PDF, not the resource title).
    id: "style-with-strategy",
    service: "vendor-advocacy",
    title: "Style with Strategy: 9 Steps to Prepare Your Home for Sale",
    summary: "Nine steps to maximise buyer competition — spend where it matters and prepare with a plan. Includes a preparation-priority worksheet and an inspection-day checklist.",
    release: "approved",
    status: "published",
    fileUrl: null,
    gated: true,
    coverUrl: "/assets/resources/style-with-strategy-cover.jpg",
    pageCount: 14,
    fileSize: "3.6 MB",
    reviewedAt: "31 October 2026",
  },
  {
    // Insights / guides audience — NOT the homepage and NOT the
    // investor-first service pitch. Approved shorter web edition supplied by
    // owner 31 Oct 2026 (10 pages, fillable planning worksheet). Co-branded
    // Key Choice Lending. Never marketed as a guarantee of school-zone
    // eligibility or finance approval ("Nearby is not the same as eligible").
    id: "first-home-school-suburb-guide",
    service: "insights",
    title: "First Home & School Suburb Guide",
    summary: "A quick-start guide for first-home buyers: seven example suburbs, a three-suburb shortlist worksheet, and how the 5% Deposit Scheme fits — school scores and property budgets in one place.",
    release: "approved",
    status: "published",
    fileUrl: null,
    gated: true,
    coverUrl: "/assets/resources/first-home-school-suburb-web-guide-cover.jpg",
    pageCount: 10,
    fileSize: "2.4 MB",
    reviewedAt: "31 October 2026",
  },
  {
    // Corporate brochure — APPROVED final supplied by owner 3 Nov 2026.
    // UNGATED by owner direction: no email capture, no login. Served at the
    // stable /brochure URL → versioned static asset. Bytes preserved exactly
    // (SHA-256 verified against the approved Drive source).
    id: "corporate-brochure",
    service: "insights",
    title: "80 Metrics Corporate Brochure",
    summary: "Who we are, how we work and the four ways we help — buying, selling, understanding a suburb, and reviewing what you already own.",
    release: "approved",
    status: "published",
    fileUrl: "/assets/brochure/80-metrics-brochure-approved-2026-11-03.pdf",
    gated: false,
    coverUrl: null,
    pageCount: 20,
    fileSize: "approx. 8.6 MB",
    reviewedAt: "3 November 2026",
  },
  {
    // Insights / guides — FULL REFERENCE edition (243 pages, ~3 MB). The
    // 392-page combined edition was superseded by this redesigned full
    // reference, supplied by owner 31 Oct 2026. HELD from public download
    // pending the owner’s final source/data licence confirmation — it
    // includes the national school appendix. Same marketing constraints as
    // the quick-start guide. Visible only in owner preview until then.
    //
    // SECURITY (31 Oct 2026): the held PDF + cover are NOT in the public web
    // root — a hidden card does not make a directly-addressable PDF private.
    // Held bytes live in access-controlled staging at
    //   /app/private-staging/resources/elite-school-suburbs.pdf
    // (outside frontend/public, not served). Move back into
    // frontend/public/assets/resources/ and set fileUrl ONLY after licence
    // confirmation. coverUrl is null so no public cover reference exists.
    id: "elite-school-suburbs-full-reference",
    service: "insights",
    title: "Elite School Suburbs — Full Reference",
    summary: "The complete directory: 171 suburbs, 348 shortlisted school entries, indicative 3-bedroom house prices and 5% deposit illustrations, with the national school appendix.",
    editionNote: "Full reference (243 pages) — release pending. Master retained privately; owner has questioned the brief-only offer (1 Nov); release for THIS website needs destination-specific confirmation.",
    release: "pending",
    status: "hold",
    fileUrl: null,
    coverUrl: null,
    pageCount: 243,
    fileSize: "3.1 MB",
    reviewedAt: null,
  },
];

// Corporate brochure stays separate from service ebooks and report sample
// walkthroughs — a seller guide is never a SuburbIQ or Assessment sample.

export const CONTACT_PHONE_LOCAL = "(03) 8773 4599";

// Homepage "answers before capture" section — real on-page answers using
// existing approved factual content. No market predictions or advice promises.
export const HOME_QUESTIONS = [
  {
    q: "Where should I buy?",
    answer:
      "Start with your goals, budget and circumstances — then identify locations and property types that fit, and test them against the evidence: supply and demand, sales volume, days on market, vendor discounting and the rental fundamentals underneath asking ranges. The area has to earn its place in your search.",
    services: [
      { key: "suburbiq", to: "/suburbiq", label: "SuburbIQ", receives: "Suburb-level research: report + Matthew’s video walkthrough — $220 incl. GST" },
      { key: "buyer", to: "/buyer-advocacy", label: "Buyer Advocacy", receives: "Search, assessment and purchase representation" },
    ],
  },
  {
    q: "Should I sell or keep my property?",
    answer:
      "Review what the property earns, what it costs to hold, how it fits your goals, and what the alternatives are — including opportunity cost. Sometimes the evidence says retain or restructure rather than sell; advice does not have to lead to a transaction.",
    services: [
      { key: "review", to: "/property-portfolio-assessment", label: "Property & Portfolio Assessment", receives: "Property-specific advice: written assessment, two meetings, recommendations — $2,200 incl. GST" },
    ],
  },
  {
    q: "How do I buy well?",
    answer:
      "Decide your number from evidence before you negotiate. That means property assessment, due diligence and price evidence first — then negotiation and auction representation through to settlement, on your side of the table only.",
    services: [
      { key: "buyer", to: "/buyer-advocacy", label: "Buyer Advocacy", receives: "Search, assessment and purchase representation — from $13,200 incl. GST" },
    ],
  },
  {
    q: "How do I sell well?",
    answer:
      "Treat the sale as a campaign you control: an independent view on timing, pricing and method of sale, agent selection without referral-fee conflicts, and oversight of the campaign through to settlement.",
    services: [
      { key: "vendor", to: "/vendor-advocacy", label: "Vendor Advocacy", receives: "Sale planning, agent selection and campaign oversight — $4,400 incl. GST" },
    ],
  },
];

// Explainer video slots. Public mode: a real <video> renders only when status
// is "published" AND sourceUrl is set; otherwise a written explanation with a
// working anchor renders in the same position (no dead players, no
// coming-soon). Owner staging: append ?media-preview=1 on the PREVIEW host to
// see labelled placement frames (never enabled on production hosts).
export const MEDIA_SLOTS = [
  {
    id: "home-explainer",
    title: "How 80 Metrics helps you decide",
    sourceUrl: null,
    posterUrl: null,
    transcriptUrl: null,
    captionsUrl: null,
    duration: null,
    status: "planned",
    fallback: "Understand your position, decide with evidence, and act only when it makes sense — the framework behind every 80 Metrics engagement, explained by Matthew.",
    fallbackLink: { to: "/how-we-work", label: "See how it works" },
  },
  {
    id: "suburbiq-inside",
    title: "Inside a SuburbIQ report",
    sourceUrl: null,
    posterUrl: null,
    transcriptUrl: null,
    captionsUrl: null,
    duration: null,
    status: "planned",
    fallback: "Every report answers one agreed suburb question in the same structure — Answer, Evidence, Trade-offs, Assumptions — then Matthew walks you through it on video.",
    fallbackLink: { to: "/how-we-work", label: "See how it works" },
  },
  {
    id: "review-includes",
    title: "What your assessment includes",
    sourceUrl: null,
    posterUrl: null,
    transcriptUrl: null,
    captionsUrl: null,
    duration: null,
    status: "planned",
    fallback: "A written assessment of up to four properties you already own, clear recommendations, and two meetings — discovery, then a findings walkthrough with Matthew.",
    fallbackLink: { to: "/how-we-work", label: "See how it works" },
  },
  {
    id: "buyer-brief",
    title: "From brief to purchase",
    sourceUrl: null,
    posterUrl: null,
    transcriptUrl: null,
    captionsUrl: null,
    duration: null,
    status: "planned",
    fallback: "We start with your goals, budget and circumstances, identify suitable locations and property options, then assess, negotiate and represent you through to settlement.",
    fallbackLink: { to: "/how-we-work", label: "See how it works" },
  },
  {
    id: "vendor-plan",
    title: "From sale plan to settlement",
    sourceUrl: null,
    posterUrl: null,
    transcriptUrl: null,
    captionsUrl: null,
    duration: null,
    status: "planned",
    fallback: "An independent view on timing, pricing and method, agent selection without referral-fee conflicts, and campaign oversight through to settlement.",
    fallbackLink: { to: "/how-we-work", label: "See how it works" },
  },
];

// Buyer Advocacy total professional fee tiers — source: owner-approved
// brochure "80 Metrics Brochure - ver 2 - 30 Oct", p21. Single shared source
// for the service page, Fees page, FAQs and the concierge.
export const BUYER_FEE_TIERS = [
  { budget: "Under $1,000,000", fee: "$13,200" },
  { budget: "$1,000,000 to under $2,000,000", fee: "$16,500" },
  { budget: "$2,000,000 and above", fee: "$22,000" },
];

export const BUYER_FEE_NOTES = [
  "Total professional fee including GST, set at engagement using your agreed purchase budget.",
  "Retainer: $2,200 at signing, credited against the total fee. Balance payable at settlement.",
  "90-day exclusive engagement.",
  "Purchase costs, legal work and inspections are additional.",
];

export const BUYER_FEE_FIXED_EXPLANATION =
  "Your fixed fee is agreed at engagement using your purchase budget. It is not calculated as a percentage of the final purchase price.";

// Supported by the owner brochure (p4): fixed professional fees; no
// selling-agent commissions, referral fees, developer commissions or rebates.
export const PAID_BY_YOU =
  "We work for you and are paid by you. We do not receive referral fees or share in your selling agent’s commission.";

export const VENDOR_FEE_CONTEXT =
  "The $4,400 incl. GST 80 Metrics professional fee is separate from the selling agent’s fees and campaign costs.";

export const AGENT_SELECTION_NOTE =
  "Our professional fee doesn’t depend on which selling agent you appoint.";
